export const getBaseApiUrl = () =>
  process.env.NODE_ENV === 'development' ? `` : process.env.REACT_APP_API_URL || `https://lk.doconline.ru`;
